<div class="dashboard-content" style="padding: 120px 40px 50px">

  <section class="analysis">
    <div class="dashboard-page-title">
      <h1>{{ "analytic2.heading" | translate }}</h1>
      <div class="dropdown export-dropdown">
        <button class="Download-button dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
            <path
              d="M18.25 8.99997C20.3077 9.07357 22.0549 10.6169 21.9987 12.6843C21.9856 13.1653 21.7993 13.7598 21.4266 14.9488C20.5298 17.8104 19.0226 20.2944 15.6462 20.8904C15.0255 21 14.3271 21 12.9303 21H11.0697C9.6729 21 8.9745 21 8.35384 20.8904C4.97739 20.2944 3.47018 17.8104 2.57336 14.9488C2.20072 13.7598 2.01439 13.1653 2.00132 12.6843C1.94512 10.6169 3.6923 9.07357 5.75001 8.99997"
              stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M12 14L12 3M12 14C11.2998 14 9.99153 12.0057 9.5 11.5M12 14C12.7002 14 14.0085 12.0057 14.5 11.5"
              stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <span>{{ "analytic2.export" | translate }}</span>
          <i class="fa-solid fa-angle-down ms-2"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="downloadPDF()">
              <i class="fa-solid fa-file-pdf me-2" style="color: #e74c3c;"></i>
              PDF
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="downloadExcel()">
              <i class="fa-solid fa-file-excel me-2" style="color: #27ae60;"></i>
              Excel
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="heading">
      <h2>{{ "analysis.overview" | translate }}</h2>
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home"
            type="button" role="tab" aria-controls="nav-home" aria-selected="true" (click)="changeTimeFilter('week')">
            {{ "analysis.week" | translate }}
          </button>
          <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button"
            role="tab" aria-controls="nav-profile" aria-selected="false" (click)="changeTimeFilter('month')">
            {{ "analysis.month" | translate }}
          </button>
          <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button"
            role="tab" aria-controls="nav-contact" aria-selected="false" (click)="changeTimeFilter('year')">
            {{ "analysis.year" | translate }}
          </button>
        </div>
      </nav>
    </div>
    <div class="tab-content" id="nav-tabContent">
      <div class="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
      </div>
      <div class="cards-container">
        <div class="card" *ngFor="let item of analysis" nz-tooltip
          [nzTooltipTitle]="item.number === 0 ? 'No data exist' : item.tooltip" nzTooltipPlacement="bottom">
          <div class="card-title">
            <p class="icon">
              <img *ngIf="item.icon" [src]="item.icon" width="40" height="40" />
            </p>
            <span class="title">
              {{ item.title | translate }}
            </span>
          </div>
          <p class="number">{{ item.displayNumber || item.number }}</p>
          <div class="progress-content">
            <p class="increase" *ngIf="item.percentage > 0">
              <i class="fa-solid fa-arrow-up"></i>
              <span>{{ item.percentage }}%</span>
            </p>
            <p class="decrease" *ngIf="item.percentage < 0">
              <i class="fa-solid fa-arrow-down"></i>
              <span>{{ Math.abs(item.percentage) }}%</span>
            </p>
            <p class="neutral" *ngIf="item.percentage === 0">
              <span>0%</span>
            </p>
            <p class="progress-text">
              {{ selectedTimeFilter === 'week' ? 'vs last week' :
              selectedTimeFilter === 'month' ? 'vs last month' :
              'vs last year' }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 mt-4">
        <div class="row row-gap-4">
          <div class="col-xl-7">
            <div class="chart_div">
              <div class="d-flex justify-content-between align-items-center">
                <h2 class="title">{{ "analytic2.reports" | translate }}</h2>
                <div class="dropdown week-dropdown-data">
                  <button class="btn dropdown-toggle week-button" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    {{ timeFilterLabel }}
                    <i class="fa-solid fa-angle-down"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="javascript:void(0)" (click)="changeTimeFilter('week')"
                        [class.active]="selectedTimeFilter === 'week'">
                        This Week
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="javascript:void(0)" (click)="changeTimeFilter('month')"
                        [class.active]="selectedTimeFilter === 'month'">
                        This Month
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="javascript:void(0)" (click)="changeTimeFilter('year')"
                        [class.active]="selectedTimeFilter === 'year'">
                        This Year
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="graph overflow-hidden">
                <apx-chart [series]="barChart.series || []" [chart]="barChart.chart!"
                  [plotOptions]="barChart.plotOptions!" [dataLabels]="barChart.dataLabels!" [stroke]="barChart.stroke!"
                  [colors]="barChart.colors!" [tooltip]="barChart.tooltip!" [legend]="barChart.legend!"
                  [xaxis]="barChart.xaxis!" [yaxis]="barChart.yaxis!" [fill]="barChart.fill!">
                </apx-chart>
              </div>
            </div>
          </div>
          <div class="col-xl-5 ps-2">
            <div class="chart_div">
              <div class="d-flex justify-content-between align-items-center">
                <h2 class="title">
                  {{ "analysis.analytic" | translate }}
                </h2>
                <div class="dropdown">
                  <a class="btn btn-secondary dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </a>
                </div>
              </div>
              <div class="donut-chart-container d-flex justify-content-center mt-2">
                <div class="donut-wrapper position-relative">
                  <!-- Google Donut Chart -->
                  <google-chart [type]="donutChart.type" [data]="donutChart.data" [columns]="donutChart.columnNames"
                    [options]="donutChart.options" class="google-chart">
                  </google-chart>
                  <!-- Center Text Overlay -->
                  <div class="donut-center-text position-absolute">
                    <p class="percentage-text">{{ activePercentage }}%</p>
                    <p class="label-text">Integrate</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <div class="table-container">
          <div class="d-flex justify-content-between align-items-center">
            <h2 class="title">
              {{ "analysis.monitoring" | translate }}
            </h2>
            <button class="btn btn-primary" style="width: fit-content" routerLink="/home/campaigns/monitoring">
              {{ "analysis.view" | translate }}
            </button>
          </div>

          <div class="table-content">
            <!-- <app-table [listOfData]="listOfData" [columns]="columns" [isPagination]="false"
                                        [nzScrollWidth]="'1400px'"></app-table> -->
            <div class="table">
              <nz-table #basicTable [nzData]="listOfData" [nzScroll]="{ x: '1200px' }" nzShowSizeChanger
                nzTableLayout="fixed" [nzShowPagination]="false">
                <thead>
                  <tr>
                    <th *ngFor="let column of columns" [nzWidth]="column.width">
                      {{ column.label | translate }}
                    </th>

                    <th nzWidth="150px" nzRight>
                      {{ "contestTableDetails.action" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of basicTable.data">
                    <td class="truncate-cell">
                      <div class="tooltip-container" (mouseenter)="onMouseEnter($event, data.contestName)"
                        (mouseleave)="onMouseLeave($event)">
                        <span>
                          {{
                          data.contestName?.length > 12
                          ? (data.contestName | slice: 0:8) + '…'
                          : data.contestName
                          }}
                        </span>
                        <div class="custom-tooltip" *ngIf="data.contestName?.length > 12">
                          {{ data.contestName }}
                        </div>
                      </div>
                    </td>

                    <td>{{ data.contestFormat }}</td>
                    <td>{{ data.contestType }}</td>
                    <td>{{ data.numberOfLevels }}</td>
                    <td class="truncate-cell">
                      <div class="tooltip-container" (mouseenter)="onMouseEnter($event, data.location)">
                        <span>
                          {{
                          data.location?.length > 12
                          ? (data.location | slice: 0:8) + '…'
                          : data.location
                          }}
                        </span>
                        <div class="custom-tooltip" *ngIf="data.location?.length > 8">
                          {{ data.location }}
                        </div>
                      </div>
                    </td>

                    <td class="truncate-cell">
                      <div class="tooltip-container" (mouseenter)="onMouseEnter($event, data.prize)"
                        (mouseleave)="onMouseLeave($event)">
                        <span>
                          {{
                          data.prize?.length > 12
                          ? (data.prize | slice: 0:8) + '…'
                          : data.prize
                          }}
                        </span>
                        <div class="custom-tooltip" *ngIf="data.prize?.length > 12">
                          {{ data.prize }}
                        </div>
                      </div>
                    </td>
                    <td>{{ data.totalViews }}</td>
                    <td>{{ data.totalJoins }}</td>
                    <td>{{ data.completionRate }}</td>
                    <td>{{ data.numberOfWinners }}</td>
                    <!-- <td>{{ data.rewardStatus }}</td> -->
                    <td>{{ data.clicks }}</td>
                    <!-- <td>{{ data.timestamp }}</td> -->
                    <td>{{ data.gender }}</td>
                    <td>{{ data.ageBreakdown }}</td>
                    <!-- <td>{{ data.locationHeatmap }}</td> -->

                    <!-- Location Heatmap (opt.) -->
                    <td nzRight>
                      <div class="d-flex justify-content-center">
                        <svg style="cursor: pointer" (click)="viewDetail(data.id)" xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24" width="28" height="28" color="#4a4a4a" fill="none">
                          <path d="M16.5 7.5L6 18" stroke="#4a4a4a" stroke-width="2" stroke-linecap="round"></path>
                          <path
                            d="M8 6.18791C8 6.18791 16.0479 5.50949 17.2692 6.73079C18.4906 7.95209 17.812 16 17.812 16"
                            stroke="#4a4a4a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>